<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Expenditure</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-2">
          <v-btn color="primary" small to="/new-expense">
            <v-icon left dark>mdi-plus</v-icon>Record Expense
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12" class="subtitle-2 text--primary">
            <span>Total: {{ TotalExpenses | currency }}</span>
            <!-- start of table -->
            <v-data-table :mobile-breakpoint="0" :headers="headers" :items="expenses" :search="search">
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/expenses/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- delete action template -->
              <template v-slot:item.delete="{ item }">
                <v-btn color="red" @click="openDeleteModal(item)" text><v-icon left>mdi-close</v-icon> Delete Expense
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.Amount="{ item }">
                <span>{{ item.Amount | currency }}</span>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- expense dialog modal-->
        <v-dialog v-model="deleteDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title> Delete / Disable Expense </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="deleteDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="text--primary subtitle-2">
                  <v-col cols="12">
                    Are you sure you want to delete this expense ?
                  </v-col>

                  <v-col cols="12">
                    <span style="font-size: 20px">{{ expenseItem.category && expenseItem.category.Name }}</span>
                  </v-col>

                  <v-col cols="12">
                    <span style="font-size: 20px">Amount: {{ expenseItem.Amount }}</span>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="red" dark :loading="loader" @click="deleteExpense">Yes, Delete</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal-->

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loader: false,
    expenseItem: {},
    deleteDialog: false,
    headers: [
      { text: "Category", value: "category.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Paid Via", value: "account.Name" },
      { text: "Description", value: "narration" },
      { text: "Staff", value: "staff.name" },
      { text: "Date", value: "DocDate" },
      { text: "Action", value: "action" },
      { text: "Delete", value: "delete" },
    ],
    expenses: [],
    TotalExpenses: 0,
  }),
  methods: {
    openDeleteModal(data) {
      this.expenseItem = data;
      this.deleteDialog = true;
    },
    getExpenses() {
      const data = {
        StartDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10),
      };

      const url = "/expenditure-report";
      const self = this;
      this.$store
        .dispatch("post", { data, url })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.expenses = res.ResponseData.expenses;
            self.TotalExpenses = res.ResponseData.TotalExpenses;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteExpense() {
      const url = `/expenditure/${this.expenseItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.getExpenses();
            self.deleteDialog = false;
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getExpenses();
  },
};
</script>